export default class HTMLContentHelper {
  static hasHtmlStringInnerText = (string) => {
    return string !== '' && string !== '<p><br></p>' && string !== undefined && string !== null
  }
}